import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Axios from "axios";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../../AddFeeGroup/AddFeeGroup.css";
import { url } from "../../../../../../Config/Config";
import { withRouter } from "react-router";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../../Components/FormLoader/FormLoader";

class AddFeeHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        feeTypeName: "",
        price: "",
      },
      priceRef: createRef(),
      feeTypes: [],
      headError: "",
      priceError: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.getFeeTypes();
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        feeTypeName: data.feeTypeName,
        price: data.price,
      },
    });
  };

  getFeeTypes = async () => {
    try {
      const response = await Axios.get(`${url}/api/fee-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.feesType.length !== 0) {
        this.setState({
          feeTypes: response.data.feesType,
          isEmpty: false,
        });
      } else {
        this.setState({
          feeTypes: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getFeeTypes();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  checkError = () => {
    let headError = "";
    let priceError = "";

    if (this.state.data.feeTypeName === "") {
      headError = "Please select fee type head";
    }

    if (!this.state.data.price === 0) {
      priceError = "price must be greater than 0";
    }

    if (headError || priceError) {
      this.setState({
        headError,
        priceError,
      });
      return true;
    } else {
      this.setState({
        headError: "",
        priceError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        if (this.props.editStatus) {
          const response = await Axios.put(
            `${url}/api/fee-groups/${this.props.groupId}/fee/${this.props.data._id}`,
            this.state.data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (
            response.data.message === "Fee edited successfully in the group"
          ) {
            this.props.getGroupDetails(this.props.groupId);
            this.props.handleCancelEdit();
          }
        } else {
          const response = await Axios.post(
            `${url}/api/fee-groups/${this.props.groupId}`,
            this.state.data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Fee added successfully to the group") {
            this.setState({
              data: {
                feeTypeName: "",
                price: "",
              },
              loading: false,
            });
            this.props.getGroupDetails(this.props.groupId);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { data, feeTypes } = this.state;
    return (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="feeTypeName"
            select
            required
            fullWidth
            variant="outlined"
            margin="normal"
            SelectProps={{ native: true }}
            error={this.state.headError ? true : false}
            helperText={this.state.headError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.feeTypeName}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            {feeTypes.map((feeType, index) => (
              <option key={index} value={feeType.name}>
                {feeType.name}
              </option>
            ))}
          </TextField>
        </TableCell>
        <TableCell align="center">
          <TextField
            name="price"
            type="number"
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.priceError ? true : false}
            helperText={this.state.priceError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.priceRef}
            onWheel={() => this.handleWheel(this.state.priceRef)}
            value={data.price}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Delete"
                className={classes.tooltip}
                onClick={() => this.props.handleCancelEdit()}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="Add"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddFeeHead)));
